import {
  Column,
  Container,
  Hr,
  Img,
  Link,
  Row,
  Text,
} from "@react-email/components";

const Footer = ({ cdn_url }: { cdn_url: string }) => {
  const style = getStyle();
  return (
    <>
      <Container style={style.container}>
        <Hr style={style.hr} />
        <Img
          width={"20%"}
          style={{ marginTop: "20px" }}
          src={`${cdn_url}/system/kyd-logo-email.png`}
        />
        <Text
          style={{
            fontWeight: "bold",
            fontSize: "14px",
            color: "black",
            lineHeight: "22px",
          }}
        >
          Need help? You can reply to this email, or get in touch by contacting{" "}
          <Link href="mailto:support@kydlabs.com">support@kydlabs.com</Link>.
        </Text>
      </Container>
      {/*<Container>
        <Social cdn_url={cdn_url} />
        </Container>*/}
      <Container>
        <Row>
          <Column>
            <Text style={style.text}>
              Powered by KYD LABS ©{new Date().getFullYear()}
            </Text>
          </Column>
        </Row>
        <Row>
          <Column>
            <Text style={style.text}>All rights reserved</Text>
          </Column>
        </Row>
        <Row>
          <Column>
            <Text style={style.text}>
              228 Park Ave South #99043 New York, NY 10003
            </Text>
          </Column>
        </Row>
      </Container>
    </>
  );
};

const getStyle = () => ({
  text: {
    margin: 0,
    fontSize: "14px",
    lineHeight: "22px",
    color: "black",
  },
  hr: {
    borderTop: "1px solid #333",
  },
  container: {
    marginTop: "32px",
  },
});

export default Footer;
